module.exports = __webpack_public_path__ + "img/game8.38552d2b.png";